export enum PropertyBuildingStyleEnum {
  single_family_home= 'single_family_home',
  townhome = 'townhome',
  garden = 'garden',
  low_rise = 'low_rise',
  mid_rise = 'mid_rise',
  hi_rise = 'hi_rise',
}

export const PropertyBuildingStyleLabels = {
  [PropertyBuildingStyleEnum.single_family_home]: 'Single Family Home',
  [PropertyBuildingStyleEnum.townhome]: 'Townhome',
  [PropertyBuildingStyleEnum.garden]: 'Garden',
  [PropertyBuildingStyleEnum.low_rise]: 'Low Rise',
  [PropertyBuildingStyleEnum.mid_rise]: 'Mid Rise',
  [PropertyBuildingStyleEnum.hi_rise]: 'Hi-Rise',
}

export const getPropertyBuildingStyleLabel = (value: PropertyBuildingStyleEnum) => {
  return PropertyBuildingStyleLabels[value] || value;
};
